import React from 'react';
import { useSelector } from 'react-redux';
import { getMarketplace } from 'reducers/marketplace/MarketplaceSelectors';
import { MarketplaceType } from 'types/Marketplace';

export const useMarketplace = () => {
    return useSelector(getMarketplace);
};

export const useMarketplaceAddress = () => {
    const marketplace = useMarketplace();

    const marketplaceAddress = React.useMemo(() => {
        const address: Array<string> = [];

        if (
            marketplace.businessType === MarketplaceType.MOBILE ||
            marketplace.businessType === MarketplaceType.LOCAL_BUSINESS
        ) {
            let addressLines = '';

            addressLines += marketplace.address?.addressLineOne.trim();

            if (marketplace.address?.addressLineTwo) {
                addressLines += ` ${marketplace.address?.addressLineTwo.trim()}`;
            }

            address.push(addressLines + ',');
        }

        address.push(`${marketplace.address?.city.trim()} ${marketplace.address?.state.trim()},`);

        if (
            marketplace.businessType === MarketplaceType.MOBILE ||
            marketplace.businessType === MarketplaceType.LOCAL_BUSINESS
        ) {
            address.push(marketplace.address?.zipcode.trim() ?? '');
        }

        return address.join(' ');
    }, [marketplace]);

    return {
        marketplaceAddress
    };
};
